import styled from "styled-components/macro";
import React, { Component } from "react";
import { ReactComponent as LockIcon } from "../assets/lock.svg";
import { ReactComponent as LocationPinIcon } from "../assets/location-pin.svg";
import { ReactComponent as LogoGoogleIcon } from "../assets/logo-google.svg";
import { ReactComponent as PersonBikeDeliveryIcon } from "../assets/person-bike-delivery.svg";
import { ReactComponent as KnifeSpoonIcon } from "../assets/knife-spoon-restaurant.svg";
import { getImageUrl } from "../utils/imageUrl";
import { ReactComponent as CloseIcon } from "../assets/close-icon.svg";
import { ReactComponent as StorePlaceholder } from "../assets/store-placeholder.svg";
import { ReactComponent as BoxReturner } from "../assets/box-returner-filled.svg";
import { ReactComponent as ContainerPlaceholder } from "../assets/container-placeholder.svg";
import { withTranslation } from "react-i18next";
import { getIsReturnStationType } from "../utils/storeTypes";

export const SubContainer = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  bottom: 50px; /* Adjust the value as needed */
  z-index: 1; /* Adjust the value to ensure proper layering */
  /* Add other styling properties as needed */
  bottom: 50px;
  z-index: 1;
  position: absolute;
  width: 100% !important;
`;

export const StoreCardContainer = styled.div`
  height: fit-content;
  display: flex;
  width: 100% !important;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`;

const StoreCardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  scroll-behavior: smooth;
  overflow-y: auto;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  width: 500px;
  max-width: 90%;
  @media screen and (min-width: 520px) {
    background: white;
  }

  @media screen and (max-width: 519px) {
    width: 100%;
    max-width: 100%;
  }
`;

const StoreCardPanel = styled.div`
  position: absolute;
  background: white;
  z-index: 1001;
  overflow-y: auto;
  will-change: transform;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};

  /* Hide scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Mobile: Modal slides up from bottom */
  @media screen and (max-width: 519px) {
    left: 16px;
    right: 16px;
    bottom: 0;
    max-height: calc(100% - 32px);
    border-radius: 20px 20px 0 0;
    width: calc(100% - 32px);
    transform: ${(props) =>
      props.isVisible ? "translateY(0)" : "translateY(100%)"};
  }
  /* Tablet/Desktop: Panel slides in from left */
  @media screen and (min-width: 520px) {
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    border-radius: 0;
    transform: ${(props) =>
      props.isVisible ? "translateX(0)" : "translateX(-100%)"};
  }
`;

const CloseButton = styled.button`
  position: sticky;
  top: 16px;
  right: 16px;
  margin-left: auto;
  background: rgba(28, 26, 32, 0.8);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  color: #ffffff;
  z-index: 999999;
  pointer-events: auto;

  @media screen and (max-width: 519px) {
    top: 46px;
    right: 32px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

const StoreCardContent = styled.div`
  position: relative;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  margin: 24px 0 24px 0;
`;

const ImageGallery = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100%;
  background: white;
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 3px;
  }
`;

// Responsive gallery image (no border radius)
const GalleryImage = styled.img`
  height: 300px;
  width: ${(props) => (props.isSingle ? "100%" : "200px")};
  object-fit: ${(props) => (props.isSingle ? "contain" : "cover")};
  flex-shrink: 0;
  background: white;

  @media (min-width: 520px) {
    width: ${(props) => (props.isSingle ? "100%" : "300px")};
    height: 300px;
  }
`;

// Placeholder container for when no images are available
const PlaceholderContainer = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;

  @media (min-width: 520px) {
    width: 100%;
  }
`;

const StoreName = styled.h1`
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 800;
  line-height: 2.2rem;
  margin-bottom: 24px;
  color: #1c1a20;
`;

const ReturnSection = styled.div`
  padding: 0 24px 24px 24px;
  margin-bottom: 56px;
`;

const ReturnTitle = styled.h3`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px 0;
  color: #1c1a20;
`;

// Responsive container grid — always 4 per row
const ContainerGallery = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
`;

const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  aspect-ratio: 0.75;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(28, 26, 32, 0.08);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(28, 26, 32, 0.15);
  }
`;

const ContainerImage = styled.img`
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  flex-shrink: 0;
`;

const ContainerLabelContainer = styled.div`
  background-color: rgba(28, 26, 32, 0.08);
  border-radius: 0;
  padding-top: 4px;
  padding-bottom: 4px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContainerLabel = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: #1c1a20;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  hyphens: auto;
  padding: 4px 8px;

  ${ContainerWrapper}:hover & {
    -webkit-line-clamp: 2;
    word-break: break-word;
    text-align: center;
    font-size: 9px;
    padding: 0px 8px;
  }
`;

const InfoSection = styled.div`
  padding: 8px 24px 0px 24px;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #333;

  & a {
    display: flex;
    align-items: center;
    gap: 14px;
    text-decoration: underline;
    color: #1a73e8;
    font-weight: 500;
  }
`;

const InfoIcon = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
`;

const EmployeesOnlyText = styled.span`
  color: #ff3800;
  font-weight: 500;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: opacity 0.2s;
  opacity: ${(props) => (props.isLoading ? 1 : 0)};
  pointer-events: ${(props) => (props.isLoading ? "auto" : "none")};
`;

class StoreCard extends Component {
  componentDidMount() {
    // Add keyboard event listener
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    // No need to prevent body scroll since the modal is now contained within the map
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape" && this.props.isVisible) {
      this.props.onClose();
    }
  };

  handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      this.props.onClose();
    }
  };

  getGoogleMapsUrl = (store) => {
    if (store.lonlat) {
      return `https://www.google.com/maps/search/?api=1&query=${store.lonlat.latitude},${store.lonlat.longitude}`;
    }
    if (store.address) {
      const addressParts = [
        store.address.streetname,
        store.address.streetno,
        store.address.street_extra,
        store.address.zip,
        store.address.city,
        store.address.state,
        store.address.country,
      ].filter(Boolean);

      if (addressParts.length > 0) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          addressParts.join(" ")
        )}`;
      }
    }
    return null;
  };

  getFormattedAddress = (address) => {
    if (!address) return null;

    // Format as "zipcode city" as requested
    const parts = [];
    if (address.streetname) {
      let street = address.streetname;
      if (address.streetno) street += " " + address.streetno;
      if (address.street_extra) street += " " + address.street_extra;
      parts.push(`${street},`);
    }
    if (address.zip) parts.push(address.zip);
    if (address.city) parts.push(address.city);

    return parts.length > 0 ? parts.join(" ") : null;
  };

  getDeliveryServices = (store) => {
    const services = [];

    // Check ordering_services first
    if (store.ordering_services && Array.isArray(store.ordering_services)) {
      store.ordering_services.forEach((service) => {
        if (service.ordering_service_type) {
          // Capitalize first letter and format service name
          const formattedType = service.ordering_service_type
            .toLowerCase()
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          services.push({
            type: formattedType,
            url: service.url,
          });
        }
      });
    }

    return services;
  };

  render() {
    const { store, onClose, isVisible, isLoading, t } = this.props;

    // The panel is always rendered to allow for animations.
    // Content is only shown if a store object exists.
    const hasStoreData = !!store;

    const {
      name,
      type,
      images = [],
      accepted_container_types: acceptedContainerTypes = [],
      address,
      product_tags = [],
      employee_only,
    } = store || {};

    const isReturnStation = getIsReturnStationType(type);

    const googleMapsUrl = hasStoreData ? this.getGoogleMapsUrl(store) : null;
    const deliveryServices = hasStoreData
      ? this.getDeliveryServices(store)
      : [];
    const formattedAddress = hasStoreData
      ? this.getFormattedAddress(address)
      : null;

    return (
      <StoreCardOverlay isVisible={isVisible} onClick={this.handleOverlayClick}>
        <CloseButton onClick={onClose}>
          <CloseIcon color="white" />
        </CloseButton>
        <StoreCardPanel isVisible={isVisible}>
          {hasStoreData ? (
            <StoreCardContent>
              {/* Image Gallery */}
              {images?.length > 0 ? (
                <ImageGallery>
                  {images?.map((image, index) => (
                    <GalleryImage
                      key={index}
                      src={getImageUrl(500, image.url)}
                      alt={`Image of ${name} ${index + 1}`}
                      isSingle={images?.length === 1}
                    />
                  ))}
                </ImageGallery>
              ) : (
                <PlaceholderContainer>
                  {isReturnStation ? (
                    <BoxReturner
                      width={180}
                      height={180}
                      style={{ color: "#E0E0E0" }}
                    />
                  ) : (
                    <StorePlaceholder
                      width={180}
                      height={180}
                      style={{ color: "#E0E0E0" }}
                    />
                  )}
                </PlaceholderContainer>
              )}

              <InfoSection>
                {/* Store Name */}
                <StoreName>{name}</StoreName>

                {/* Google Maps Link */}
                {googleMapsUrl && (
                  <InfoRow>
                    <a
                      href={googleMapsUrl}
                      style={{
                        textDecorationColor: "#1C1A20",
                        color: "#1C1A20",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InfoIcon>
                        <LogoGoogleIcon />
                      </InfoIcon>
                      <span>{t("open_in_google_maps")}</span>
                    </a>
                  </InfoRow>
                )}

                {/* Location */}
                {formattedAddress && (
                  <InfoRow>
                    <InfoIcon>
                      <LocationPinIcon />
                    </InfoIcon>
                    <span>{formattedAddress}</span>
                  </InfoRow>
                )}

                {/* Cuisine/Tags */}
                {product_tags?.length > 0 && (
                  <InfoRow>
                    <InfoIcon>
                      <KnifeSpoonIcon />
                    </InfoIcon>
                    <span>{product_tags?.join(", ")}</span>
                  </InfoRow>
                )}

                {/* Delivery Services */}
                {deliveryServices.length > 0 && (
                  <InfoRow>
                    <InfoIcon>
                      <PersonBikeDeliveryIcon />
                    </InfoIcon>
                    <span>
                      {deliveryServices
                        .map((service) => service.type)
                        .join(", ")}
                    </span>
                  </InfoRow>
                )}

                {/* Employees Only Badge */}
                {employee_only && (
                  <InfoRow>
                    <InfoIcon style={{ color: "#FF3800" }}>
                      <LockIcon />
                    </InfoIcon>
                    <EmployeesOnlyText>{t("employees_only")}</EmployeesOnlyText>
                  </InfoRow>
                )}
              </InfoSection>

              <Divider />
              {/* Return Section */}
              {acceptedContainerTypes.length > 0 && (
                <ReturnSection>
                  <ReturnTitle>{t("return_container")}</ReturnTitle>
                  <ContainerGallery>
                    {acceptedContainerTypes.map((containerType, index) => (
                      <ContainerWrapper key={index}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1,
                          }}
                        >
                          {containerType?.image_url ? (
                            <ContainerImage
                              src={getImageUrl(256, containerType?.image_url)}
                              alt={
                                containerType?.name || `Container ${index + 1}`
                              }
                              title={containerType?.name}
                            />
                          ) : (
                            <ContainerPlaceholder
                              width={48}
                              height={48}
                              style={{ color: "#E0E0E0" }}
                            />
                          )}
                        </div>
                        <ContainerLabelContainer>
                          <ContainerLabel>{containerType.name}</ContainerLabel>
                        </ContainerLabelContainer>
                      </ContainerWrapper>
                    ))}
                  </ContainerGallery>
                </ReturnSection>
              )}
            </StoreCardContent>
          ) : (
            <PlaceholderContainer>
              <StorePlaceholder
                width={180}
                height={180}
                style={{ color: "#E0E0E0" }}
              />
            </PlaceholderContainer>
          )}
        </StoreCardPanel>
      </StoreCardOverlay>
    );
  }
}

export default withTranslation()(StoreCard);
